// ไฟล์: frontend/src/pages/NewsPage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './NewsPage.css';

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const newsResponse = await axios.get('/news');
        setNews(newsResponse.data.news);
        
        const categoriesResponse = await axios.get('/categories');
        setCategories(categoriesResponse.data.categories);
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching news:', error);
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // กรองข่าวตามหมวดหมู่
  const filteredNews = activeCategory === 'all' 
    ? news 
    : news.filter(item => item.category_id === parseInt(activeCategory));

  // ฟังก์ชันจัดรูปแบบวันที่
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('th-TH', options);
  };

  if (loading) {
    return (
      <div className="loading-container">
        {/* <div className="loading-spinner">กำลังโหลดข้อมูล...</div> */}
      </div>
    );
  }

  return (
    <div className="news-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">
            <i className="fas fa-newspaper"></i> ข่าวสารการศึกษา
          </h1>
          <p className="page-description">
            อัพเดทข่าวสารการศึกษา การอบรม ประชุม นโยบาย และทุนการศึกษาล่าสุด
          </p>
        </div>

        {/* Category Filter */}
        <div className="news-filter">
          <div className="filter-label">กรองตามหมวดหมู่:</div>
          <div className="filter-options">
            <button 
              className={`filter-option ${activeCategory === 'all' ? 'active' : ''}`}
              onClick={() => setActiveCategory('all')}
            >
              ทั้งหมด
            </button>
            {categories.map(category => (
              <button 
                key={category.id}
                className={`filter-option ${activeCategory === category.id.toString() ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id.toString())}
              >
                <i className={`fas fa-${category.icon}`}></i> {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* News List */}
        {filteredNews.length > 0 ? (
          <div className="news-grid">
            {filteredNews.map(item => (
              <div className="news-card" key={item.id}>
                <div className="news-thumbnail">
                  <Link to={`/news/${item.id}`}>
                    <img 
                      src={item.thumbnail 
                        ? `${process.env.REACT_APP_API_URL}/uploads/${item.thumbnail}`
                        : '/assets/default-news.jpg'} 
                      alt={item.title} 
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/assets/default-news.jpg';
                      }}
                    />
                  </Link>
                  <div className="news-category">
                    <i className={`fas fa-${categories.find(cat => cat.id === item.category_id)?.icon || 'folder'}`}></i>
                    {categories.find(cat => cat.id === item.category_id)?.name || 'ทั่วไป'}
                  </div>
                </div>
                <div className="news-content">
                  <h2 className="news-title">
                    <Link to={`/news/${item.id}`}>{item.title}</Link>
                  </h2>
                  <div className="news-meta">
                    <div className="news-date">
                      <i className="far fa-calendar-alt"></i> {formatDate(item.created_at)}
                    </div>
                    <div className="news-views">
                      <i className="far fa-eye"></i> {item.view_count} ครั้ง
                    </div>
                  </div>
                  <div className="news-excerpt">
                    {item.content?.length > 150
                      ? `${item.content.substring(0, 150).replace(/<[^>]*>/g, '')}...`
                      : item.content?.replace(/<[^>]*>/g, '')}
                  </div>
                  <Link to={`/news/${item.id}`} className="news-read-more">
                    อ่านต่อ <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">
              <i className="fas fa-newspaper"></i>
            </div>
            <h3>ไม่พบข่าวสารที่ต้องการ</h3>
            <p>ไม่พบข่าวสารในหมวดหมู่ที่คุณเลือก โปรดเลือกหมวดหมู่อื่น</p>
            <button 
              className="btn btn-primary"
              onClick={() => setActiveCategory('all')}
            >
              <i className="fas fa-sync"></i> ดูข่าวทั้งหมด
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsPage;
